import { useMemo } from 'react'
import ReactModal from 'react-modal'

import { TGetItemFn, TSelectPlan, TSetItemFn } from '@/config/types'
import { PageName } from '@/enums/pageName'
import { PaymentScreenVersion } from '@/enums/paymentScreenVersion'

import { Close } from '@/shared/icons/Close'

import {
  PaymentScreenModal,
  PaymentScreenModalV3_2,
  PaymentScreenModalV3_4,
} from '@/commonPages/paymentScreenPage'
import {
  TPaymentScreenPageOptions,
  TPaymentScreenPageProps,
} from '@/commonPages/paymentScreenPage/types'

export type TPaymentModalBlockProps = {
  modalId: string
  getItem: TGetItemFn
  setItem: TSetItemFn
  pageConfig: TSelectPlan
  paymentOptions?: TPaymentScreenPageOptions
  closeModal: () => void
  openedModalId: string
}

const paymentScreenMap: Record<
  PaymentScreenVersion,
  React.FunctionComponent<TPaymentScreenPageProps>
> = {
  [PaymentScreenVersion.v3_2]: PaymentScreenModalV3_2,
  // Version 3.3 is identical to 3.2 except for CSS differences.
  [PaymentScreenVersion.v3_3]: PaymentScreenModalV3_2,
  [PaymentScreenVersion.v3_4]: PaymentScreenModalV3_4,
  [PaymentScreenVersion.default]: PaymentScreenModal,
}

function getPaymentScreenComponent(): React.FunctionComponent<TPaymentScreenPageProps> {
  return (
    paymentScreenMap[window.config.PAYMENT_SCREEN_VERSION as PaymentScreenVersion] ||
    paymentScreenMap[PaymentScreenVersion.default]
  )
}

export const PaymentModalBlock = ({
  modalId,
  getItem,
  setItem,
  pageConfig,
  paymentOptions,
  openedModalId,
  closeModal,
}: TPaymentModalBlockProps) => {
  const { modalCloseDelay = 600, popupAppLogo } = pageConfig

  const PaymentPopupModalComponent = useMemo(() => getPaymentScreenComponent(), [])

  return (
    <ReactModal
      key={modalId}
      portalClassName="payment-modal-portal"
      overlayClassName="payment-modal-overlay"
      closeTimeoutMS={modalCloseDelay}
      className="payment-modal"
      ariaHideApp={false}
      shouldCloseOnOverlayClick={true}
      isOpen={openedModalId == modalId}
      id={modalId.toString()}
      onRequestClose={closeModal}
    >
      <button className="close-button" onClick={closeModal}>
        <Close />
      </button>
      {popupAppLogo && <div className="app-logo-container">{popupAppLogo}</div>}
      {paymentOptions && (
        <PaymentPopupModalComponent
          key={PageName.paymentScreen + `${modalId}`}
          getItem={getItem}
          setItem={setItem}
          config={window.config}
          {...paymentOptions}
          isAdditional={paymentOptions.isAdditional || false}
          isIntroOffer={paymentOptions.isIntroOffer || false}
        />
      )}
    </ReactModal>
  )
}
